import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { RootState } from "../../BusinessObjects/Redux/app/store";
import { useAppSelector } from "../../BusinessObjects/Redux/app/hook";
import cubeApiClient from "../../BusinessObjects/cubeApiService";
import { useNavigate, useSearchParams } from "react-router-dom";
import Apikeys from "../../BusinessObjects/apiKeys";
import { ResourceNames } from "../../Utils/ResourceNames";
import { FormTypeEnum } from "../../modules/app/types/FormType";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import "./FormBuilderPage.css";
import {
  Box,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  TextField,
  Alert,
} from "@mui/material";
import { IForm } from "../../modules/app/types/entites/forms.interface";
import { IFormField } from "../../modules/app/types/entites/forms_fields.interface";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { IFormGroup } from "../../modules/app/types/entites/forms_groups.interface";

import { red } from "@mui/material/colors";
import { ArrowBackIosSharp } from "@mui/icons-material";
const clone = require("clone");
function generateKey(formGroupId: number, field_ID: number) {
  return formGroupId.toString() + "_" + field_ID.toString();
}

const FormBuilderPage = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [EditGroupId, setEditGroupId] = useState<Number>();
  const [selectedGroups, setSelectedGroups] = useState<{
    [key: string]: {
      from: number;
      to: number;
      field_ID: number;
    };
  }>({});
  const [showAlert, setShowAlert] = useState(false);
  const alertRef = useRef(null);
  const tokenApi = useAppSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useAppSelector(
    (state: RootState) => state.user.userProfile
  );

  const navigate = useNavigate();
  const isLoggedIn = useAppSelector((state) => state.user.isLoggedIn);

  const [form, setForm] = useState<IForm | undefined>(undefined);

  const [searchParams] = useSearchParams();
  const id = React.useMemo(() => {
    if (searchParams.get(FormTypeEnum.jump))
      return searchParams.get(FormTypeEnum.jump);
    if (searchParams.get(FormTypeEnum.menu))
      return searchParams.get(FormTypeEnum.menu);
    return searchParams.get(FormTypeEnum.resource);
  }, [searchParams]);
  const formType = React.useMemo(() => {
    if (searchParams.get(FormTypeEnum.jump)) return "JUMPMENU";
    if (searchParams.get(FormTypeEnum.menu)) return "MENU";
    return "RESOURCE";
  }, [searchParams]);

  const formfilters = {
    formType: formType,
    id: id && !isNaN(Number(id)) ? Number(id) : 0,
  };

  const generateUrlFilter = () => {
    if (!id) throw new Error("Id is undefined");

    if (isNaN(Number(id))) throw new Error("Id is not a number");

    if (formType === "JUMPMENU") return `${FormTypeEnum.jump}=${id}`;

    if (formType === "MENU") return `${FormTypeEnum.menu}=${id}`;

    if (formType === "RESOURCE") return `${FormTypeEnum.resource}=${id}`;

    throw new Error("Unable to get id ");
  };
  const { data, isLoading, isError } = useQuery(
    Apikeys.form(tokenApi, userProfile?.customer_ID || 0, formfilters),
    () => {
      const service = new cubeApiClient();

      var urlFilter = generateUrlFilter();

      const requrl = `api/sys/${ResourceNames.Forms}/query?` + urlFilter;

      return service.getItems(requrl, tokenApi);
    },
    {
      enabled: id && !isNaN(Number(id)) && isLoggedIn ? true : false,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  React.useEffect(() => {
    if (data && data[0]) {
      //
      setForm(data[0]);
    }
  }, [data]);

  useEffect(() => {
    if (showAlert) {
      const scrollOptions: ScrollToOptions = {
        behavior: "smooth",
        top: document.body.scrollHeight, // Scroll to the bottom of the page
      };
      window.scrollTo(scrollOptions);
    }
  }, [showAlert]);

  const ValidateObject = () => {
    const service = new cubeApiClient();
    const Requrl = `api/sys/${ResourceNames.Forms}`;

    updateObject();
  };

  const updateObject = () => {
    const service = new cubeApiClient();

    let objectToEdit = form;
    if (!objectToEdit) {
      return;
    }
    const Requrl = `api/sys/${ResourceNames.Forms}`;
    if (searchParams.get(FormTypeEnum.jump)) {
      let v = searchParams.get(FormTypeEnum.jump);
      if (!v) return;
      if (isNaN(parseInt(v))) return;

      objectToEdit.ResourceJump_Id = parseInt(v);
    } else if (searchParams.get(FormTypeEnum.menu)) {
      let v = searchParams.get(FormTypeEnum.menu);
      if (!v) return;
      if (isNaN(parseInt(v))) return;
      objectToEdit.MenuItem_ID = parseInt(v);
    } else if (searchParams.get(FormTypeEnum.resource)) {
      let v = searchParams.get(FormTypeEnum.resource);
      if (!v) return;
      if (isNaN(parseInt(v))) return;
      objectToEdit.Resource_ID = parseInt(v);
    }
    service.updateObject(objectToEdit, Requrl, tokenApi).then(
      () => {
        setShowAlert(true);
        window.location.reload();
        navigate(-1);
      },
      (error: any) => {
        let stringError = "Errore nel salvataggio:" + JSON.stringify(error);
      }
    );
  };

  const isFirst = (group: IFormGroup) => {
    if (!form?.FormsGroups) return false;

    let smallest = form?.FormsGroups?.[0].Ordinal;
    for (var i in form?.FormsGroups) {
      if (form.FormsGroups[i].Ordinal < smallest) {
        smallest = form.FormsGroups[i].Ordinal;
      }
    }

    if (group.Ordinal === smallest) {
      return true;
    }
    return false;
  };

  const isLast = (group: IFormGroup): boolean => {
    if (!form?.FormsGroups) return false;

    let largest = form?.FormsGroups?.[0].Ordinal;
    for (var i in form?.FormsGroups) {
      if (form.FormsGroups[i].Ordinal > largest) {
        largest = form.FormsGroups[i].Ordinal;
      }
    }

    return group.Ordinal === largest;
  };

  const handleNewGroup = () => {
    let FormClone: IForm = clone(form);
    let newgroup: IFormGroup;

    let lastGroup: IFormGroup | undefined =
      FormClone.FormsGroups?.[FormClone.FormsGroups.length - 1];

    if (lastGroup) {
      // se non esiste vuol dire che il form non ha gruppi
      newgroup = {
        Group_ID: lastGroup.Group_ID + 1,
        Form_ID: lastGroup.Form_ID,
        GroupTitle: "",
        Ordinal: lastGroup.Ordinal + 1,
        ind_origine: lastGroup.ind_origine,
        FormsFields: [],
      };

      FormClone.FormsGroups?.push(newgroup);
    } else {
      newgroup = {
        Group_ID: 0,
        Form_ID: FormClone.Form_ID,
        GroupTitle: "",
        Ordinal: 1,
        ind_origine: 0,
        FormsFields: [],
      };
    }
    setForm({ ...FormClone });
    setEditGroupId(newgroup.Group_ID);
  };

  const handleRenameGroup = (
    form: IForm,
    group: IFormGroup,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let newLabel = String(event.target.value);
    if (!newLabel) {
      alert("Input non valido");

      return;
    }
    let editedForm: IForm = clone(form);
    let groupIndex = editedForm.FormsGroups?.findIndex(
      (fg: IFormGroup) => group.Group_ID === fg.Group_ID
    );
    if (groupIndex === undefined || editedForm.FormsGroups === undefined)
      return;
    editedForm.FormsGroups[groupIndex].GroupTitle = newLabel;

    console.log(editedForm);
    setForm({ ...editedForm });
    setEditGroupId(NaN);
  };

  const handleDeleteGroup = (form: IForm, formgroup: IFormGroup) => {
    if (formgroup.FormsFields?.length === 0) {
      let formClone: IForm = clone(form);
      let groupindex = formClone.FormsGroups?.findIndex(
        (fg: IFormGroup) => fg.Group_ID === formgroup.Group_ID
      );
      if (groupindex === undefined) return;
      formClone?.FormsGroups?.splice(groupindex, 1);

      setForm({ ...formClone });
      console.log(form);

      return;
    }

    alert("Gruppo non vuoto");
  };

  const handleMoveGroupUp = (formGroupId: number) => {
    if (!form) return;

    let formClone: IForm = clone(form);
    let formGroup = formClone.FormsGroups?.find(
      (fg: IFormGroup) => fg.Group_ID === formGroupId
    );

    if (!formGroup) return;

    const groupIndex = formClone.FormsGroups?.findIndex(
      (fg: IFormGroup) => fg.Group_ID === formGroupId
    );

    if (groupIndex === undefined || groupIndex <= 0 || !formClone.FormsGroups)
      return;

    const tempOrdinal = formClone.FormsGroups[groupIndex].Ordinal;
    formClone.FormsGroups[groupIndex].Ordinal =
      formClone.FormsGroups[groupIndex - 1].Ordinal;
    formClone.FormsGroups[groupIndex - 1].Ordinal = tempOrdinal;

    setForm({ ...formClone });
  };

  const handleMoveGroupDown = (formGroupId: number) => {
    if (!form) return;

    let formClone: IForm = clone(form);
    let formGroup = formClone.FormsGroups?.find(
      (fg: IFormGroup) => fg.Group_ID === formGroupId
    );

    if (!formGroup) return;

    const groupIndex = formClone.FormsGroups?.findIndex(
      (fg: IFormGroup) => fg.Group_ID === formGroupId
    );

    if (
      !formClone.FormsGroups ||
      groupIndex === undefined ||
      groupIndex >= formClone.FormsGroups.length - 1
    )
      return;

    const tempOrdinal = formClone.FormsGroups[groupIndex].Ordinal;
    formClone.FormsGroups[groupIndex].Ordinal =
      formClone.FormsGroups[groupIndex + 1].Ordinal;
    formClone.FormsGroups[groupIndex + 1].Ordinal = tempOrdinal;

    setForm({ ...formClone });
  };

  const handleMoveUp = (formGroupId: number, field: IFormField) => {
    if (!form) return;

    let formClone: IForm = clone(form);
    let formGroup = formClone.FormsGroups?.find(
      (fg: IFormGroup) => fg.Group_ID === formGroupId
    );

    if (!formGroup || !formGroup.FormsFields) return;

    let fieldIndex = formGroup.FormsFields.findIndex(
      (ff: IFormField) => ff.Field_ID === field.Field_ID
    );

    if (fieldIndex > 0) {
      const tempOrdinal = formGroup.FormsFields[fieldIndex].Ordinal;
      formGroup.FormsFields[fieldIndex].Ordinal =
        formGroup.FormsFields[fieldIndex - 1].Ordinal;
      formGroup.FormsFields[fieldIndex - 1].Ordinal = tempOrdinal;

      setForm({ ...formClone });
    }
  };

  const handleMoveDown = (formGroupId: number, field: IFormField) => {
    if (!form) return;

    let formClone: IForm = clone(form);
    let formGroup = formClone.FormsGroups?.find(
      (fg: IFormGroup) => fg.Group_ID === formGroupId
    );

    if (!formGroup || !formGroup.FormsFields) return;

    let fieldIndex = formGroup.FormsFields.findIndex(
      (ff: IFormField) => ff.Field_ID === field.Field_ID
    );

    if (fieldIndex < formGroup.FormsFields.length - 1) {
      const tempOrdinal = formGroup.FormsFields[fieldIndex].Ordinal;
      formGroup.FormsFields[fieldIndex].Ordinal =
        formGroup.FormsFields[fieldIndex + 1].Ordinal;
      formGroup.FormsFields[fieldIndex + 1].Ordinal = tempOrdinal;

      setForm({ ...formClone });
    }
  };

  const handlemovefield = (fg_Id: number, field: IFormField) => {
    const toMove = selectedGroups[generateKey(fg_Id, field.Field_ID)];

    if (!toMove) return;

    let newform = clone(form);
    let formindex = newform.FormsGroups?.findIndex(
      (fg: IFormGroup) => fg.Group_ID === toMove.from
    );

    let fieldindex = newform.FormsGroups?.[formindex].FormsFields?.findIndex(
      (ff: IFormField) => ff.Field_ID === toMove.field_ID
    );

    // console.log(
    //   newform.FormsGroups?.[formindex].formFields.findIndex(
    //     (ff: IFormField) => ff.Field_ID === toMove.field_ID
    //   )
    // );

    newform?.FormsGroups?.[formindex]?.FormsFields?.splice(fieldindex, 1);

    let dest = newform.FormsGroups?.findIndex(
      (fg: IFormGroup) => fg.Group_ID === toMove.to
    );

    //deve settare il suo Ordinal all'ultimo valore disponibile nel gruppo
    //di destinazione cosi da non avere duplicati accidentali
    let tmpArr = newform?.FormsGroups?.[dest]?.FormsFields.map(
      (ff: IFormField) => {
        return ff.Ordinal;
      }
    );

    let lastOrdinal = Math.max(...tmpArr);
    field.Ordinal = ++lastOrdinal;

    newform?.FormsGroups?.[dest]?.FormsFields?.push(field);
    console.log(newform);
    setForm(newform);

    //dopo lo spostamento lo rimuove dal dizionario
    let tmpSelectedGroups = clone(selectedGroups);
    delete tmpSelectedGroups[generateKey(fg_Id, field.Field_ID)];
    setSelectedGroups(tmpSelectedGroups);
  };

  const handleMenuItemClick = (
    fg_Id: number, // gruppo di partenza
    ff_Id: number, // field corrente
    event: SelectChangeEvent<string | number>
  ) => {
    let tmpForm: IForm | undefined = clone(form);
    if (!tmpForm) return;
    let formgroup = tmpForm.FormsGroups?.find((fg) => fg.Group_ID === fg_Id);
    if (!formgroup) return;
    let formField = formgroup.FormsFields?.find((ff) => ff.Field_ID === ff_Id);
    if (!formField) return;

    var selectedValue = Number(event.target.value); // gruppo a cui andrà aggiunto

    const itemKey = generateKey(fg_Id, ff_Id);
    //aggiorno stato per sapere quali field hanno cambiaot gruppo.
    if (selectedValue === fg_Id) {
      //elimino la chiave dal dizionario
      let tmpSelectedGroups = clone(selectedGroups);
      delete tmpSelectedGroups[itemKey];
      setSelectedGroups(tmpSelectedGroups);
    } else {
      setSelectedGroups((prev) => {
        return {
          ...prev,
          [itemKey]: { from: fg_Id, to: selectedValue, field_ID: ff_Id },
        };
      });
    }

    //aggiorno il campo group_id del field selezionato
    formField.Group_ID = selectedValue;
    setForm(tmpForm);
  };

  const handleVisibility = (fg_Id: number, ff_Id: number) => {
    if (!form) return;
    let formClone: IForm = clone(form);
    let formGroup = formClone.FormsGroups?.find(
      (fg: IFormGroup) => fg.Group_ID === fg_Id
    );
    let formField = formGroup?.FormsFields?.find(
      (ff) => ff && ff.Field_ID === ff_Id
    );

    if (!formField) return;
    formField.Is_Visible = !formField.Is_Visible;
    setForm(formClone);
  };

  const getType = (type: number) => {
    switch (type) {
      case 1:
      case 2:
        return "checkbox";

      case 4:
      case 15:
      case 33:
        // Datetime
        return "Data";
      case 31:
        // Date
        return "Data";
      case 12:
      case 22:
      case 3:
      case 8:
        return "Testo";

      default:
        return "Unknown";
    }
  };

  const renderFormField = (formGroupId: number, field: IFormField) => {
    const selectedGroupKey = `${formGroupId}-${field.Field_ID}`;
    const selectedGroup = selectedGroups[selectedGroupKey] || formGroupId;

    const fieldStyle = {
      filter: field.Is_Visible ? "none" : "blur(1px)",
      transition: "filter 0.3s ease",
    };

    return (
      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{ marginBottom: "20px" }}
      >
        <Grid
          key={`${formGroupId}-${field.Field_ID}`}
          item
          xs={12}
          style={fieldStyle}
        >
          <Grid container alignItems="start" justifyContent="space-between">
            <Grid item>
              <Grid>
                <IconButton onClick={() => handleMoveUp(formGroupId, field)}>
                  <KeyboardArrowUpIcon />
                </IconButton>
              </Grid>
              <Grid>
                <IconButton onClick={() => handleMoveDown(formGroupId, field)}>
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item>
              {field.Field_Label} : {getType(field.Field_Type)}
            </Grid>
            <Grid item xs={12} md={6}>
              <IconButton
                onClick={() => handleVisibility(formGroupId, field.Field_ID)}
              >
                {field.Is_Visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>

              <>
                <span>&nbsp;&nbsp;</span>
                <FormControl style={{ minWidth: 150 }}>
                  <InputLabel id="demo-simple-select-label">
                    Cambia Gruppo
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={field.Group_ID}
                    label=" Cambia Gruppo"
                    onChange={(event) =>
                      handleMenuItemClick(formGroupId, field.Field_ID, event)
                    }
                  >
                    {form?.FormsGroups?.map((groups) => (
                      <MenuItem key={groups.Group_ID} value={groups.Group_ID}>
                        {groups.GroupTitle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <IconButton
                  onClick={() => {
                    handlemovefield(formGroupId, field);
                  }}
                >
                  <CheckCircleIcon
                    color={
                      Object.keys(selectedGroups).find(
                        (k) => k === generateKey(formGroupId, field.Field_ID)
                      )
                        ? "success"
                        : undefined
                    }
                  ></CheckCircleIcon>
                </IconButton>
              </>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  if (isError || id === null || id === undefined || isNaN(Number(id))) {
    return <div>Error</div>;
  }
  if (isLoading) {
    return <div>Caricamento</div>;
  }
  if (!form) {
    return <div>Form non caricato </div>;
  }

  return (
    <Container maxWidth="lg">
      <Typography
        variant="h4"
        component="div"
        gutterBottom
        color="primary"
        textTransform={"uppercase"}
        fontWeight={600}
        textAlign={"center"}
      >
        Crea/Modifica Form
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography
        variant="h6"
        component="div"
        gutterBottom
        textTransform={"uppercase"}
        fontWeight={600}
        textAlign={"center"}
      >
        Modifica form {form.Title}
      </Typography>
      {form.FormsGroups?.sort((groupA, groupB) => {
        return (groupA.Ordinal || 0) - (groupB.Ordinal || 0);
      }).map((sortedGroup) => (
        <Typography
          variant="body2"
          component="div"
          gutterBottom
          color="inherit"
          textTransform={"uppercase"}
          fontWeight={600}
          key={sortedGroup.Group_ID}
        >
          <Divider sx={{ my: 2 }} />

          <Box display="flex" alignItems="center">
            <Grid>
              <IconButton
                onClick={() => handleMoveGroupUp(sortedGroup.Group_ID)}
              >
                {isFirst(sortedGroup) ? null : <KeyboardArrowUpIcon />}
              </IconButton>
            </Grid>
            <Grid>
              <IconButton
                onClick={() => handleMoveGroupDown(sortedGroup.Group_ID)}
              >
                {isLast(sortedGroup) ? null : <KeyboardArrowDownIcon />}
              </IconButton>
            </Grid>

            {sortedGroup.Group_ID === EditGroupId ? (
              <TextField
                defaultValue={sortedGroup.GroupTitle}
                size="small"
                onBlur={(event) => handleRenameGroup(form, sortedGroup, event)}
              ></TextField>
            ) : sortedGroup && sortedGroup.GroupTitle ? (
              sortedGroup.GroupTitle
            ) : (
              ""
            )}

            <IconButton
              onClick={() => {
                setEditGroupId((prevEditGroupId) =>
                  prevEditGroupId !== sortedGroup.Group_ID
                    ? sortedGroup.Group_ID
                    : NaN
                );
              }}
            >
              <EditIcon color="primary"></EditIcon>
            </IconButton>

            <IconButton onClick={() => handleDeleteGroup(form, sortedGroup)}>
              <DeleteIcon
                sx={{ color: red[500], marginLeft: "auto" }}
              ></DeleteIcon>
            </IconButton>
          </Box>
          <Divider sx={{ my: 2 }} />
          {sortedGroup.FormsFields?.sort((fieldA, fieldB) => {
            // Sort the FormsFields based on their Ordinal property
            return (fieldA.Ordinal || 0) - (fieldB.Ordinal || 0);
          }).map((field: IFormField) =>
            renderFormField(sortedGroup.Group_ID, field)
          )}
        </Typography>
      ))}
      <Divider sx={{ my: 2 }} />
      <Grid
        className="FormBuilderPage-formFieldContainer"
        style={{ textAlign: "center" }}
      ></Grid>
      <Box>
        <LoadingButton
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => {
            handleNewGroup();
          }}
        >
          Nuovo gruppo
        </LoadingButton>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={ValidateObject}
          // disabled={isEqual(myObject, myObjectEdit.objectToEdit)}
          startIcon={<SaveIcon />}
        >
          Salva
        </LoadingButton>
      </Box>
      {showAlert ? (
        <Box
          sx={{
            width: "40%",
            height: "100%",
            margin: "auto", // Center horizontally
            marginTop: "10px",
            textAlign: "center", // Center text horizontally
          }}
        >
          <Alert
            severity="success"
            variant="filled"
            sx={{
              width: "100%", // Full width
              borderRadius: "4px", // Rounded corners
              textAlign: "center", // Center text
              fontFamily: "Arial, sans-serif", // Change font
            }}
          >
            Salvataggio Completato ...Attendere
          </Alert>
        </Box>
      ) : null}
      <ul>
        {Object.entries(selectedGroups).map(([key, value]) => (
          <li key={key}>
            {key}: {JSON.stringify(value, null, 2)}
          </li>
        ))}
      </ul>
    </Container>
  );
};

export default FormBuilderPage;
